module.exports = __webpack_public_path__ + "static/legion_loyalty_mtg_clb-2b53d6dc1ac7146cbeac37c3cd781b6f.jpg";